<div class="finalize-container p-shadow-3 p-p-4">
  <div class="p-d-flex p-flex-column p-ai-center p-text-center mb-6">
    <!-- Icono ilustrativo -->
    <i class="pi pi-check-circle" style="font-size: 3rem; color: #4caf50"></i>

    <!-- Mensaje principal -->
    <h2 class="p-mt-3 p-mb-2" style="color: #333; font-weight: 600">¡Estamos casi listos!</h2>

    <!-- Mensaje descriptivo -->

    <p class="p-text-secondary p-mb-4" style="font-size: 1.1rem">
      Por favor, acepta todos los términos y condiciones para continuar. Una vez aceptados, haz clic en el botón
      <strong>Finalizar</strong> para continuar con el proceso de selección de la vacante
      <strong>{{ person?.requisition?.perfil?.cargo }}</strong>. Esto nos permitirá avanzar al siguiente paso.
    </p>
  </div>

  <!-- Consentimientos -->

  <form [formGroup]="form" class="p-mt-3">
    <!-- Contenedor de 2 columnas: izquierda (checkboxes) / derecha (firma) -->
    <div class="grid">
      <!-- Columna izquierda: 2 checkboxes -->
      <div class="col-12 md:col-6">
        <div miForm class="text-left">
          <!-- Checkbox 1 -->
          <div
            [miCol]="12"
            miFormField
            [miFormFieldError]="getErrorMessage('digitalSignatureConsent', 'Debe aceptar los términos y condiciones para continuar')"
          >
            <mat-checkbox formControlName="digitalSignatureConsent">
              <label class="p-text-secondary" for="digitalSignatureConsent">
                Yo <b>{{ nombreCompleto | titlecase }}</b> identificado con documento número
                <b>{{ person?.candidateInfo?.identificacion }}</b> AUTORIZO a Misión Empresarial S.A.S. realizar el uso de mi firma digital
                para plasmarla en los formularios de afiliación de EPS, Caja de Compensación Familiar y documento de Control Epidemiológico.
              </label>
            </mat-checkbox>
          </div>

          <!-- Checkbox 2 -->
          <div
            [miCol]="12"
            miFormField
            [miFormFieldError]="getErrorMessage('generalConsent', 'Debe aceptar los términos y condiciones para continuar')"
          >
            <mat-checkbox formControlName="generalConsent">
              <label class="p-text-secondary text-left text-justify" for="generalConsent">
                Declaro que he leído y comprendo la información presentada; acepto los
                <a [href]="termsUrl" target="_blank" rel="noopener noreferrer" class="p-link"> términos y condiciones </a>, y autorizo el
                tratamiento de mis datos personales conforme a la política de privacidad.
              </label>
            </mat-checkbox>
          </div>
        </div>
      </div>

      <!-- Columna derecha: firma -->
      <div class="col-12 md:col-6 gap-2">
        <div miForm class="text-left">
          <div [miCol]="12" miFormField [miFormFieldError]="getErrorMessage('signature', 'Debe firmar el acuerdo para continuar')">
            <label for="signature" class="p-text-secondary text-left"
              >Por favor, firme en el recuadro a continuación para completar su autorización:</label
            >

            <div #signatureWrapper style="width: 100%">
              <signature-pad #signature [options]="signaturePadOptions" (drawEnd)="onSignatureEnd()"></signature-pad>
              <!-- Contenedor para alinear el botón -->
              <div class="flex justify-content-end mt-2">
                <button miButton="secondary" [miButtonIcon]="'solar:refresh-broken'" (click)="limpiar()">Limpiar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
